import script from "./UserAttributeRadio.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAttributeRadio.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRadio});
